export default __webpack_public_path__ + "1ad2573bb489e958ed4e97e6cf48a8be.ogg";